/**
 * GSAP ScrollTrigger and ScrollSmoother Initialization
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother);

let smoother;

export function initGSAP() {
    /*smoother = ScrollSmoother.create({
        smooth: 1,
        effects: true,
        smoothTouch: 0.1,
    });*/

    // Floating animation for hero video
    initHeroVideoFloat();

    ScrollTrigger.refresh();
}

function initHeroVideoFloat() {
    const heroVideo = document.querySelector('.hero-block__video-container, .hero-block__video');
    if (!heroVideo) return;

    const RADIUS = 20;

    gsap.to(heroVideo, {
        x: () => gsap.utils.random(-RADIUS, RADIUS),
        y: () => gsap.utils.random(-RADIUS, RADIUS),
        z: () => gsap.utils.random(-RADIUS, RADIUS),
        rotationX: () => gsap.utils.random(-5, 5),
        rotationY: () => gsap.utils.random(-5, 5),
        rotationZ: () => gsap.utils.random(-1, 1),
        duration: () => gsap.utils.random(10, 20),
        ease: 'Sine.easeInOut',
        repeat: -1,
        repeatRefresh: true,
        yoyo: true,
    });
}

export { gsap, ScrollTrigger, ScrollToPlugin, ScrollSmoother, smoother };
